import { useEffect, useState } from 'react'

import { database } from './index.js'
// Written by scripts/inject-seo.js at build time from the live database, so the
// values rendered before Firebase answers are never older than the last deploy.
import generated from './products.generated.json'

// Names, descriptions, images and layout stay in code; the database only
// carries price / priceFrom / soldOut / sort. Keeping the card set here means
// it never changes size when data arrives, so the slider is not rebuilt.
//
// `product` and `volume` are the payload written to Orders. They must keep
// their current shape or the Telegram notification text changes.
export const CATALOG = [
  {
    id: 'h1',
    product: 'Honey',
    volume: '1',
    unit: '1 kg',
    honeyPot: true,
    text: 'Pail of raw honey',
    fallback: { price: 15, priceFrom: false, soldOut: false, sort: 10 },
  },
  {
    id: 'h3',
    product: 'Honey',
    volume: '3',
    unit: '3 kg',
    honeyPot: true,
    text: 'Pail of raw honey',
    fallback: { price: 35, priceFrom: false, soldOut: false, sort: 20 },
  },
  {
    id: 'h7',
    product: 'Honey',
    volume: '7',
    unit: '7 kg',
    honeyPot: true,
    text: 'Pail of raw honey',
    fallback: { price: 75, priceFrom: false, soldOut: false, sort: 30 },
  },
  {
    id: 'h15',
    product: 'Honey',
    volume: '15',
    unit: '15 kg',
    honeyPot: true,
    text: 'Pail of raw honey',
    fallback: { price: 150, priceFrom: false, soldOut: false, sort: 40 },
  },
  {
    id: 'queens',
    product: 'Queens',
    volume: '',
    unit: '1',
    honeyPot: false,
    text: 'Queens',
    fallback: { price: 40, priceFrom: true, soldOut: false, sort: 50 },
  },
  {
    id: 'nuc',
    product: 'Colony',
    volume: '',
    unit: '4 Frame',
    honeyPot: false,
    text: '4 Frame nucleus colony',
    fallback: { price: 250, priceFrom: true, soldOut: false, sort: 60 },
  },
  {
    id: 'pollen',
    product: 'Pollen',
    volume: '',
    unit: '500 g',
    honeyPot: false,
    text: 'Fresh bee pollen',
    fallback: { price: 45, priceFrom: false, soldOut: false, sort: 70 },
  },
  {
    id: 'comb',
    product: 'Comb',
    volume: '',
    unit: '4” x 4”',
    honeyPot: false,
    text: 'Pure raw comb honey',
    fallback: { price: 18, priceFrom: false, soldOut: true, sort: 80 },
  },
]

// Labels for the order form selects, keyed by the value written to Orders.
export const PRODUCT_LABELS = {
  Honey: 'Honey',
  Pollen: 'Bee pollen',
  Queens: 'Queens',
  Colony: 'Nucleus colony',
  Comb: 'Comb honey',
}

const num = (value, fallback) =>
  typeof value === 'number' && isFinite(value) ? value : fallback

// Three layers, most trusted first: what the database just sent, what it held
// when the site was built, and the values written in this file. A missing node,
// a partial write or a failed read still renders a full page.
const merge = (remote) =>
  CATALOG.map((item) => {
    const data = {
      ...item.fallback,
      ...(generated[item.id] || {}),
      ...((remote && remote[item.id]) || {}),
    }
    return {
      ...item,
      price: num(data.price, item.fallback.price),
      priceFrom:
        typeof data.priceFrom === 'boolean'
          ? data.priceFrom
          : item.fallback.priceFrom,
      soldOut:
        typeof data.soldOut === 'boolean' ? data.soldOut : item.fallback.soldOut,
      sort: num(data.sort, item.fallback.sort),
    }
  }).sort((a, b) => a.sort - b.sort)

// Subscribes to /products and re-renders on every change made from the bot.
export const useProducts = () => {
  const [remote, setRemote] = useState(null)

  useEffect(() => {
    const ref = database.ref('products')

    const listener = ref.on(
      'value',
      (snapshot) => setRemote(snapshot.val()),
      (error) => {
        console.error('products listener failed, using fallback prices', error)
        setRemote(null)
      }
    )

    return () => ref.off('value', listener)
  }, [])

  return merge(remote)
}
